import "./ToggleSwitch.css"; // Arquivo CSS para o estilo do switch

const ToggleSwitch = ({ isChecked, onToggle, width = '50px', height = '23px', disabled = false }) => {
    return (
        <label className="switch" style={{ '--switch-width': width, '--switch-height': height, opacity: disabled ? 0.4 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}>
            <input data-testid='switch' type="checkbox" checked={isChecked} onChange={onToggle} disabled={disabled} />
            <span className="switch-slider"></span>
        </label>
    );
};

export default ToggleSwitch;
